import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  VectorBucketIdentifierARN,
  VectorBucketIndexARNs,
  VectorBucketIndexDataTypes,
  VectorBucketIndexDimensions,
  VectorBucketIndexDistanceMetrics,
  VectorBucketIndexEncryptionTypes,
  VectorBucketIndexKMSKeyARNs,
  VectorBucketIndexNames,
  VectorBucketIndexNonFilterableMetadataKeys,
  VectorBucketName,
  VectorBucketSecurityEncryptionType,
  VectorBucketSecurityKMSKeyARN,
} from '../../../../Components/MetadataField/MetaGridFields';

export const S3VectorBucketMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        name="None"
        arn="None"
        state="None"
        createdAt={metadata}
        owner="None"
        availabilityZone="None"
        vpc="None"
      />
      {VectorBucketIndexNames(metadata)}
      {VectorBucketIndexARNs(metadata)}
      {VectorBucketIndexDataTypes(metadata)}
      {VectorBucketIndexDimensions(metadata)}
      {VectorBucketIndexDistanceMetrics(metadata)}
      {VectorBucketIndexNonFilterableMetadataKeys(metadata)}
      {VectorBucketIndexEncryptionTypes(metadata)}
      {VectorBucketIndexKMSKeyARNs(metadata)}
      {VectorBucketName(metadata)}
      {VectorBucketIdentifierARN(metadata)}
      {VectorBucketSecurityEncryptionType(metadata)}
      {VectorBucketSecurityKMSKeyARN(metadata)}
    </Grid>
  );
};
